// src/components/Hero.jsx - OPTIMIZED FOR ONE SCREEN VIEW
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Remove body padding
    document.body.style.paddingTop = '0';
    setIsVisible(true);

    return () => {
      document.body.style.paddingTop = '';
    };
  }, []);

  const handleGetStarted = () => {
    const searchSection = document.getElementById('search-interface');
    if (searchSection) {
      searchSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section 
      id="hero" 
      className={`modern-hero-section ${isVisible ? 'fade-in' : ''}`}
    >
      {/* Animated Background */}
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="container">
        <div className="row align-items-center g-4">
          {/* Left Content */}
          <div className="col-lg-6">
            <div className="hero-content">
              {/* Badge */}
              <div className="hero-badge">
                <span className="badge-icon">⚖️</span>
                <span className="badge-text">Fast and Reliable Legal Research</span>
              </div>

              {/* Main Heading */}
              <h1 className="hero-title">
Complete Coverage of                 <span className="gradient-text"> Supreme Court & Bombay High Court Judgements</span>
              </h1>

              {/* Subtitle */}
              <p className="hero-subtitle">
                Access over 5,00,000+ authentic judgements with citations from 30+ leading law journals- trusted legal research in one place.
                
              </p>

              {/* CTA Buttons */}
              <div className="hero-cta-group">
                <button 
                  className="btn btn-hero-primary"
                 onClick={() => navigate('/signup')}
                >
                  <span> Register with Us</span>
                  <i className="bx bx-right-arrow-alt"></i>
                </button>
                
                <button 
                  className="btn btn-hero-secondary"
                  onClick={() => navigate('/pricing')}
                >
                  <span>View Plans</span>
                  <i className="bx bx-medal"></i>
                </button>
              </div>

              {/* Stats */}
              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number gradient-text">5 Lakh+</div>
                  <div className="stat-label">Judgments</div>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <div className="stat-number gradient-text">2K+</div>
                  <div className="stat-label">Active Users</div>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <div className="stat-number gradient-text">99.9%</div>
                  <div className="stat-label">Accuracy</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="col-lg-6">
            <div className="hero-visual">
              <div className="visual-card card-1">
                <div className="card-icon">
                  <i className="bx bx-search-alt"></i>
                </div>
                <div className="card-content">
                  <h4>Smart Search</h4>
                  <p>Powerful Search and Filters</p>
                </div>
              </div>

              <div className="visual-card card-2">
                <div className="card-icon">
                  <i className="bx bx-book-open"></i>
                </div>
                <div className="card-content">
                  <h4>Extensive Database</h4>
                  <p>10M+ legal documents</p>
                </div>
              </div>

              <div className="visual-card card-3">
                <div className="card-icon">
                  <i className="bx bx-brain"></i>
                </div>
                <div className="card-content">
                  <h4>100% Headnotes</h4>
                  <p>Instant case summaries</p>
                </div>
              </div>

              {/* Center Icon */}
              <div className="hero-center-icon">
                <div className="icon-wrapper">
                  <i className="bx bx-shield-alt-2"></i>
                </div>
                <div className="pulse-ring"></div>
                <div className="pulse-ring-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* ============================================
           HERO SECTION - OPTIMIZED FOR ONE SCREEN
        ============================================ */
        .modern-hero-section {
          position: relative;
          min-height: calc(100vh - 160px); /* Subtract header + banner height */
          max-height: calc(100vh - 160px);
          display: flex;
          align-items: center;
          padding: 60px 0 40px; /* Reduced padding */
          overflow: hidden;
          background: linear-gradient(135deg, #fff 0%, #fff5f0 100%);
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .modern-hero-section.fade-in {
          opacity: 1;
          transform: translateY(0);
        }

        /* Animated Background */
        .hero-background {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          overflow: hidden;
          z-index: 0;
        }

        .gradient-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.3;
          animation: float 20s ease-in-out infinite;
        }

        .orb-1 {
          width: 500px;
          height: 500px;
          background: linear-gradient(135deg, #E91E63, #E91E64);
          top: -150px;
          right: -150px;
          animation-delay: 0s;
        }

        .orb-2 {
          width: 400px;
          height: 400px;
          background: linear-gradient(135deg, #c41849, #FF1744);
          bottom: -100px;
          left: -100px;
          animation-delay: 5s;
        }

        .orb-3 {
          width: 350px;
          height: 350px;
          background: linear-gradient(135deg, #E91E64, #c41849);
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation-delay: 10s;
        }

        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(30px, -30px) scale(1.05);
          }
          66% {
            transform: translate(-30px, 30px) scale(0.95);
          }
        }

        /* Container */
        .container {
          position: relative;
          z-index: 1;
        }

        /* Hero Content */
        .hero-content {
          animation: slideInLeft 0.8s ease-out 0.3s both;
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          background: white;
          border-radius: 50px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
          margin-bottom: 20px;
          font-size: 13px;
          font-weight: 600;
          color: #333;
        }

        .badge-icon {
          font-size: 18px;
        }

        .hero-title {
          font-size: clamp(2rem, 5vw, 2.5rem); /* Reduced from 4.5rem */
          font-weight: 800;
          line-height: 1.1;
          color: #1a1a1a;
          margin-bottom: 16px; /* Reduced from 24px */
          letter-spacing: -0.02em;
        }

        .gradient-text {
          background: linear-gradient(135deg, #E91E63 0%, #E91E64 50%, #c41849 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          display: inline-block;
          animation: gradientShift 3s ease infinite;
          background-size: 200% 200%;
        }

        @keyframes gradientShift {
          0%, 100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }

        .hero-subtitle {
          font-size: clamp(0.95rem, 1.8vw, 1.1rem); /* Slightly reduced */
          line-height: 1.6;
          color: #666;
          margin-bottom: 28px; /* Reduced from 40px */
          max-width: 560px;
        }

        /* CTA Buttons */
        .hero-cta-group {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 32px; /* Reduced from 48px */
        }

        .btn-hero-primary,
        .btn-hero-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px; /* Reduced from 16px 32px */
          font-size: 15px; /* Reduced from 16px */
          font-weight: 600;
          border-radius: 12px;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .btn-hero-primary {
          background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
          color: white;
        }

        .btn-hero-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(245, 166, 35, 0.4);
        }

        .btn-hero-secondary {
          background: white;
          color: #E91E63;
          border: 2px solid #E91E63;
        }

        .btn-hero-secondary:hover {
          background: #E91E63;
          color: white;
          transform: translateY(-2px);
        }

        /* Stats */
        .hero-stats {
          display: flex;
          align-items: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .stat-item {
          text-align: left;
        }

        .stat-number {
          font-size: clamp(1.5rem, 2.5vw, 2rem); /* Reduced from 2.5rem */
          font-weight: 800;
          line-height: 1;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 13px; /* Reduced from 14px */
          color: #666;
          font-weight: 500;
        }

        .stat-divider {
          width: 2px;
          height: 35px; /* Reduced from 40px */
          background: linear-gradient(to bottom, transparent, #ddd, transparent);
        }

        /* Hero Visual */
        .hero-visual {
          position: relative;
          height: 480px; /* Reduced from 600px */
          animation: slideInRight 0.8s ease-out 0.5s both;
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .visual-card {
          position: absolute;
          background: white;
          padding: 18px; /* Reduced from 24px */
          border-radius: 14px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
          display: flex;
          gap: 14px;
          align-items: center;
          max-width: 260px; /* Reduced from 280px */
          transition: all 0.3s ease;
          animation: cardFloat 4s ease-in-out infinite;
        }

        .visual-card:hover {
          transform: translateY(-8px) !important;
          box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
        }

        @keyframes cardFloat {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-12px);
          }
        }

        .card-1 {
          top: 40px;
          left: 0;
          animation-delay: 0s;
        }

        .card-2 {
          top: 180px;
          right: 0;
          animation-delay: 1s;
        }

        .card-3 {
          bottom: 40px;
          left: 30px;
          animation-delay: 2s;
        }

        .card-icon {
          width: 54px; /* Reduced from 60px */
          height: 54px;
          border-radius: 12px;
          background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 26px; /* Reduced from 28px */
          flex-shrink: 0;
        }

        .card-content h4 {
          font-size: 15px; /* Reduced from 16px */
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 4px;
        }

        .card-content p {
          font-size: 12.5px; /* Reduced from 13px */
          color: #666;
          margin: 0;
        }

        /* Center Icon */
        .hero-center-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: -1;
        }

        .icon-wrapper {
          width: 170px; /* Reduced from 200px */
          height: 170px;
          border-radius: 50%;
          background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 70px; /* Reduced from 80px */
          position: relative;
          animation: rotate 20s linear infinite;
        }

        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .pulse-ring,
        .pulse-ring-2 {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 170px;
          height: 170px;
          border-radius: 50%;
          border: 2px solid #E91E63;
          animation: pulse 3s ease-out infinite;
        }

        .pulse-ring-2 {
          animation-delay: 1.5s;
          border-color: #c41849;
        }

        @keyframes pulse {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
          100% {
            transform: translate(-50%, -50%) scale(2);
            opacity: 0;
          }
        }

        /* Responsive */
        @media (max-width: 991px) {
          .modern-hero-section {
            min-height: auto;
            max-height: none;
            padding: 40px 0 40px;
          }

          .hero-visual {
            height: 350px;
            margin-top: 30px;
          }

          .visual-card {
            max-width: 220px;
            padding: 14px;
          }

          .card-icon {
            width: 44px;
            height: 44px;
            font-size: 22px;
          }

          .icon-wrapper {
            width: 130px;
            height: 130px;
            font-size: 55px;
          }

          .pulse-ring,
          .pulse-ring-2 {
            width: 130px;
            height: 130px;
          }
        }

        @media (max-width: 767px) {
          .modern-hero-section {
            padding: 30px 0 30px;
          }

          .hero-badge {
            padding: 6px 14px;
            font-size: 12px;
            margin-bottom: 16px;
          }

          .hero-title {
            margin-bottom: 12px;
          }

          .hero-subtitle {
            margin-bottom: 20px;
          }

          .hero-cta-group {
            flex-direction: column;
            margin-bottom: 24px;
          }

          .btn-hero-primary,
          .btn-hero-secondary {
            width: 100%;
            justify-content: center;
            padding: 12px 24px;
          }

          .hero-stats {
            justify-content: space-between;
            width: 100%;
          }

          .stat-divider {
            display: none;
          }

          .hero-visual {
            height: 300px;
          }

          .visual-card {
            padding: 12px;
            max-width: 200px;
          }

          .card-1 {
            top: 20px;
            left: -5px;
          }

          .card-2 {
            top: 140px;
            right: -5px;
          }

          .card-3 {
            bottom: 20px;
            left: 10px;
          }

          .icon-wrapper {
            width: 110px;
            height: 110px;
            font-size: 45px;
          }

          .pulse-ring,
          .pulse-ring-2 {
            width: 110px;
            height: 110px;
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;